var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: { visible: true, size: "md", "hide-header": "" },
      on: {
        hidden: function ($event) {
          return _vm.$emit("close")
        },
      },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function () {
            return [
              _c(
                "div",
                {
                  staticClass: "d-flex w-100",
                  class: {
                    "justify-content-end": _vm.showReservationMessage,
                    "justify-content-between": !_vm.showReservationMessage,
                  },
                },
                [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "outline-secondary" },
                      on: { click: _vm.closeModal },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.$t(
                              _vm.showReservationMessage
                                ? "actions.close"
                                : "cart.continue_shopping"
                            )
                          ) +
                          "\n            "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.showReservationMessage,
                          expression: "!showReservationMessage",
                        },
                      ],
                      attrs: { variant: "primary" },
                      on: { click: _vm.goToCart },
                    },
                    [
                      _c("font-awesome-icon", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.showIncassoWarning,
                            expression: "!showIncassoWarning",
                          },
                        ],
                        staticClass: "mr-2",
                        attrs: { icon: _vm.icons.faShoppingCart },
                      }),
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.showIncassoWarning
                              ? _vm.$t("cart.go_to_cart_incasso")
                              : _vm.$t("cart.go_to_cart")
                          ) +
                          "\n            "
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(
        "div",
        { staticClass: "text-center p-3" },
        [
          _vm.showReservationMessage
            ? _c("font-awesome-icon", {
                staticClass: "text-info mb-3",
                attrs: { icon: _vm.icons.faHourglassClock, size: "3x" },
              })
            : _c("font-awesome-icon", {
                staticClass: "text-success mb-3",
                attrs: { icon: _vm.icons.faCheckCircle, size: "3x" },
              }),
          _vm._v(" "),
          _vm.showReservationMessage
            ? _c("h4", [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t(`cart.${_vm.options.message_type}`)) +
                    "\n        "
                ),
              ])
            : _c("h4", [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.showIncassoWarning
                        ? _vm.$t("cart.item_added_successfully_incasso")
                        : _vm.$t("cart.item_added_successfully")
                    ) +
                    "\n        "
                ),
              ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }